module.exports = __webpack_public_path__ + "img/game_main_pc_216_off.dde909bd.png";